export default(Vue) => {
    Vue.directive("debounce", {
        inserted: function(el, binding) {
            let wait = false;
            el.addEventListener("click", () => {
                if(!wait) {
                    wait = true
                    binding.value();
                    setTimeout(() => {
                        wait = false
                    }, 1000)      
                }
            });
        }
    })
}